import axios from 'axios';
import { setAlert } from "./alert";

import { url } from '../utils/api';
import { ADD_ROOM, GET_ROOMS, ROOM_ERROR } from './types';

// Get rooms
export const getRooms = () => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.get(`${url}/api/rooms`, config);
  
          dispatch({
              type: GET_ROOMS,
              payload: res.data
          });
      } catch (err) {
          dispatch({
              type: ROOM_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
      }
  }
  
// Add room
export const addRoom = (formData, navigate) => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.post(`${url}/api/rooms/add`, formData, config);
  
          dispatch({
              type: ADD_ROOM,
              payload: res.data
          });
  
          dispatch(setAlert('Added a new room', 'success'));
          navigate('/adminDashboard/room');
      } catch (err) {
          dispatch(setAlert('This room number already exists', 'danger'));
          dispatch({
              type: ROOM_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
          
      }
}
